@if ('INTERNET_ONLY' !== type()) {
  <webmodule-order-panel (showContentChange)="showSelected.set($event)"
                         [canCollapse]="true"
                         [showContent]="showSelected()">
    <ng-container heading>
      <h3 class="mb-0" [innerHTML]="index() + '. ' + ('block.mobile.heading' | translate) "></h3>
    </ng-container>
    <ng-container content>
      <div [innerHtml]="'block.mobile.description' | translate" class="wysiwyg"></div>

      <fieldset [disabled]="false">
        <legend class="sr-only">{{ 'block.mobile.heading' | translate }}</legend>
        <div class="grid gap-4">
          @if (isLoaded()) {
            @for (item of mobileDataBundle; track item) {
              <webmodule-order-input-panel (selected)="setSelected(item, 'mobile'); showSelected.set(false)"
                                           [checked]="item === select()"
                                           [priceAlt]="item.id !== 'DATA_NONE' ? string(item.price | currency: 'EUR') : ''"
                                           [ref]="item.id"
                                           groupName="mobile">
                <ng-container label>{{ item.name }}</ng-container>
                <ng-container content>
                  <span class="mt-1 text-sm col-span-2 text-gray-500 whitespace-pre-line"
                        id="internet-{{ item.id }}-description"
                        [innerHTML]="item.description">
                  </span>
                </ng-container>
              </webmodule-order-input-panel>
            }
          } @else {
            <webmodule-order-skeleton-screen type="INPUT_PANEL" [pulse]="isLoading()"></webmodule-order-skeleton-screen>
            <webmodule-order-skeleton-screen type="INPUT_PANEL" [pulse]="isLoading()"></webmodule-order-skeleton-screen>
          }
        </div>
      </fieldset>
    </ng-container>
    @if (isLoaded()) {
      <ng-container altContent>
        @if (select(); as selected) {
          <div class="grid grid-cols-2 border-t pt-4">
            <div class="h5 mb-0">{{ selected.name }}</div>
            @if (selected.price) {
              <div class="h5 mb-0 text-right row-span-2">{{ selected.price | currency:'EUR' }} per maand</div>
            }
          </div>
        }
      </ng-container>
    }
    <ng-container footer></ng-container>
  </webmodule-order-panel>
}
